<template>
  <b-container>
    <div class="pt-5 pb-2 report-links">
      <b-row class="pt-2" v-for="report in reports" :key="report.id">
        <b-col>
          <b-button variant="outline-dark">
            <b-link v-if="$auth.isAuthenticated" :to="report.path">
              <h5 class="pt-2">{{ report.description }}</h5>
            </b-link>
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>


<script>
export default {
  name: "Reports",
  data() {
    return {
      reports: [
        { id:1, path:"/OrderOverview", description: "Order Overview Report" },
        { id:2, path:"/OrderDetails", description: "Order Details Report" },
        { id:3, path:"/ZReport", description: "Z-Report" }
      ]
    };
  },

  computed: {
  },

  methods: {
  },
};
</script>
<style>
  .report-links {
    text-align: center;
  }

  .report-links button {
    width: 50%;
  }

  .report-links a {
    color: black;
  }

  .report-links a:hover {
    color: white;
    text-decoration: none;
  }


</style>
